module.exports = __webpack_public_path__ + "assets/img/ic-recovery.44a822f7.svg";